module.exports = __webpack_public_path__ + "static/media/border-center-v.c246b590.svg";